import { Component } from 'vue-property-decorator';
import { format } from 'date-fns';
import AbstractView from '@/views/abstract-view';
import FormFieldValuesInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-field-values-interface';
import FormInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-interface';

@Component
export default class TdsInvoiceView extends AbstractView
{
    private date: Date = new Date();
    private form: FormInterface|null = null;
    private saving = false;

    created()
    {
        this.generateForm();
    }

    /**
     * Generates the form from the meeting
     */

    private generateForm()
    {
        const form: FormInterface =
        {
            items: [
                {
                    key: 'date',
                    type: 'date',
                    title: this.$t('general.field.date').toString(),
                    value: this.date,
                    required: true,
                },
            ],
        };

        this.form = Object.assign({}, form);
    }

    /**
     * Handles field value changes from the form
     *
     * @param fieldValues
     */

    private onFieldValuesChanged(fieldValues: FormFieldValuesInterface)
    {
        this.date = fieldValues.date as Date;
    }

    /**
     * Generates the invoice and downloads
     */

    private async onSave()
    {
        this.saving = true;

        try
        {
            await this.$serviceContainer.appReportService.downloadTdsInvoice(format(this.date, 'yyyy-MM'));
        }
        finally
        {
            this.saving = false;
        }
    }
}